<template>
<div class="page_set page">
    <div class="list">
        <div class="item touxiang">
            <div class="item_l">
                <span class="">店铺头像</span>
                <van-uploader :after-read="changeThumb" accept class="icon-add">
                    <img :src="thumb ? ($publicData.withHttpStart(thumb) ? thumb : imageUrl+thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
                </van-uploader>
            </div>
        </div>
        <!-- <div class="item">认证信息</div> -->
        <div class="item" @click="goPage('kuaidi-set')">快递设置</div>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            active: 0,
            goodsList: [],
            token: '',
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            checked: true,
            thumb: null, // 店铺头像
            tradesman_id: this.$route.query.tradesman_id // 匠人id
        };
    },
    created: function () {
        if (this.$route.query.status) {
            this.active = this.$route.query.status
        }
    },
    mounted: function () {

        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '店铺设置',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            // 获取列表
            this.getData();
        }

    },
    methods: {
        onTabsClick(name, title) {
            this.active = name
            this.getData()
        },
        // 获取列表
        getData() {
            var param = {
                token: this.token,
                tradesman_id: this.tradesman_id
            }
            this.$api.tradesman.info(param).then(res => {
                if (res.code == 200) {
					// this.thumb = res.result.dianpu_image
					this.thumb = res.result.thumb
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 页面跳转
        goPage(name) {
            this.$router.push({
                name: name
            })
        },
        // 修改头像
        changeThumb(file) {
            var str = ''
            // 单张上传
            this.$api.index.uploadImage({
                imgFile: file.content
            }).then(res => {
                if (res.code == 200) {
                    str = res.result.url
                    // 修改头像
                    if (str) {
                        var params = {
                            token: this.token,
                            thumb: str
                        }
                        this.$api.tradesman.thumb(params).then(res => {
                            if (res.code == 200) {
                                this.getData()
                            }
                        })
                    }
                }
            });
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
